import { render } from "./ModalLanguages.vue?vue&type=template&id=4395093f&scoped=true"
import script from "./ModalLanguages.vue?vue&type=script&lang=js"
export * from "./ModalLanguages.vue?vue&type=script&lang=js"

import "./ModalLanguages.vue?vue&type=style&index=0&id=4395093f&lang=scss&scoped=true"

import exportComponent from "/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4395093f"]])

export default __exports__